<a [routerLink]="['/data-privacy']">{{'main.links.data-privacy' | translate}}</a>

<div class="separator"></div>

<a [routerLink]="['/imprint']">{{'main.links.imprint' | translate}}</a>

<!--<div class="separator"></div>

<a [routerLink]="['/terms-and-conditions']">{{'main.links.terms&co' | translate}}</a>-->
